// @internal
import './string-operations';

window.parseIntSafe = function (n: any, d?: number): number
{
	if (d === undefined)
	{
		d = 0;
	}

	let res = null;

	try
	{
		// @ts-ignore
		res = parseInt(n);
	}
	catch (ex) { /* no problem */ }

	return (res == null || isNaN(res)) ? 0 : res;
};

window.parseFloatSafe = function (n: any, d?: number): number
{
	if (!d)
	{
		d = 0.00;
	}

	let res = null;

	try
	{
		// @ts-ignore
		res = parseFloat(n);
	}
	catch (ex) { /* no problem */ }

	return (res == null || isNaN(res)) ? 0.00 : res;
};